import API from 'app/utils/apiClient';

const getNotices = (category) => API.get(`/notices/?category=${category}`);

const getNotice = (id) => API.get(`/notices/${id}/`);

export default {
  getNotices,
  getNotice,
};



// WEBPACK FOOTER //
// ./src/app/apis/notice.js